import React from "react";

interface TemplatesTabsProps {
  activeTab: "Mine" | "All";
  setActiveTab: (tab: "Mine" | "All") => void;
  dropdownFilter: string;
  setDropdownFilter: (filter: string) => void;
  reportTypeDropdownFilter: string;
  setReportTypeDropdownFilter: (filter: string) => void;
  templateTypes: string[];
}

const TemplatesTabs: React.FC<TemplatesTabsProps> = ({
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="flex items-end font-medium space-x-4 justify-between h-[65px] 2xl:h-[70px]">
      <button
        className={`py-2 pb-5 font-medium text-sm 2xl:text-base px-3 border-b-[3px] ${
          activeTab === "Mine"
            ? " border-b-[3px] border-[#0357C9]"
            : "text-gray-400 border-transparent"
        }  `}
        onClick={() => setActiveTab("Mine")}
      >
        Mine
      </button>
      <button
        className={`py-2 pb-5 font-medium text-sm 2xl:text-base px-3 border-b-[3px] ${
          activeTab === "All"
            ? " border-b-[3px] border-[#0357C9]"
            : "text-gray-400 border-transparent"
        } `}
        onClick={() => setActiveTab("All")}
      >
        All
      </button>
    </div>
  );
};

export default TemplatesTabs;
